import { Icon } from 'src/components/Icon';
import { SVG_SIZE_M } from 'src/constants';
import { ExternalModelItem } from './components/ExternalModelItem';
import { useActiveModel } from 'src/hooks/userSettingsHooks/useActiveModel';
import { SettingLLMModels } from 'src/types/settings';
import { useContext, useMemo } from 'react';
import styles from './TextModeList.module.scss';
import AuthContext from 'src/contexts/AuthContext';
import { AppRoutes } from 'src/types';

interface TextModelListProps {
  onClick: (id: string) => void;
  modelsList: SettingLLMModels;
  showRegenerate?: boolean;
  compareModel?: string;
  isComparingMode?: boolean;
}

export const TextModelList = ({
  onClick,
  modelsList,
  showRegenerate,
  compareModel,
  isComparingMode,
}: TextModelListProps) => {
  const { activeModel } = useActiveModel();
  const { isGuestAccess } = useContext(AuthContext);

  const models = useMemo(() => {
    return modelsList.map((model) => {
      return {
        id: model.id,
        icon: model.iconName ? (
          <Icon type={model.iconName} size={SVG_SIZE_M} />
        ) : (
          <></>
        ),
        title: model.title,
        selected: isComparingMode
          ? compareModel === model.id
          : activeModel === model.id,
        availableIn: isGuestAccess ? undefined : model.availableIn,
        onClick: () => {
          if (isGuestAccess) {
            window.location.href = AppRoutes.LOGIN;
            return;
          }
          onClick(model.id);
        },
        isNew: model.isNew,
      };
    });
  }, [
    modelsList,
    isComparingMode,
    compareModel,
    activeModel,
    onClick,
    isGuestAccess,
  ]);

  return (
    <div className={styles.root}>
      {models.map((item) => (
        <ExternalModelItem
          key={item.id}
          {...item}
          showRegenerate={showRegenerate}
        />
      ))}
    </div>
  );
};
